module.exports = __webpack_public_path__ + "img/des_kalinba_3.3ebd90a4.jpg";